import { render } from "./OurTopCourses.vue?vue&type=template&id=0d50a763&ts=true"
import script from "./OurTopCourses.vue?vue&type=script&lang=ts"
export * from "./OurTopCourses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__